<template>
    <div>
        <div>
            <wp_img :src="top_img" width="100%" height="100%"></wp_img>
            <div style="padding: 20px">

                <divider>超级会员注册</divider>
                <div style="margin-top: 5%;">
                    <div>
                        超级会员{{fid}}邀请您注册
                    </div>
                    <div class="regist_input_div">
                        <van-field
                                class="regist_input"
                                label-width="70px"
                                v-model="phone_number"
                                type="tel"
                                label="手机号"
                                placeholder="请输入手机号"
                                required
                                clearable
                        ></van-field>
                    </div>

                    <div class="regist_input_div">
                        <van-row>
                            <van-col span="18" >
                                <van-field
                                        class="regist_input"
                                        label-width="70px"
                                        v-model="verify_code"
                                        type="number"
                                        label="验证码"
                                        placeholder="请输入验证码"
                                        required
                                ></van-field>
                            </van-col>
                            <van-col span="6"
                                     style="text-align: right;height: 50px; margin-top: -2px; margin-bottom: -2px;">
                                <van-button class="code_button" type="danger" plain @click="getVerifyCode" :disabled="get_verify_button_status"
                                >
                                    {{get_verify_button_name}}
                                </van-button>
                            </van-col>
                        </van-row>

                    </div>
                </div>
                <div v-if="msg">
                <!--            <span style="color:red">{{msg}}</span>-->
            </div>
                <!--        <wp_hr></wp_hr>-->
                <van-button style="margin-top: 10%; border-radius:4px" @click="checkAndRegist" type="danger" size="large"
                            :disabled="regist_button_status" :loading="loading_status"
                            :loading-text="loading_text">
                    注册
                </van-button>

                <div style="margin-top: 20px; text-align: right; font-size: 16px">
                    <div v-if="$config.project === 'mini'">
                        <a @click="loginByOldAccount">已有账号登录</a>
                    </div>
                    <div v-else>
                        <a href="/index.html">已有账号登录</a>
                    </div>
                </div>
            </div>
        </div>
        <van-action-sheet
                title="注册成功"
                v-model="showRegistSuccessData"
                style="padding-bottom: 20px; min-height: 100%"
                @close="sheetClose"
        >
            <div style="padding: 5%">
                <div class="success_data_div"
                     v-html="new_user_data"
                ></div>

                <div style="text-align: center; margin-top: 20px">
                    <van-button type="danger" plain @click="login"
                                v-clipboard:copy="new_user_data.replace('<br/>','\n')"
                                v-clipboard:success="onCopySuccess"
                                v-clipboard:error="onError"

                    >立即登录</van-button>
                </div>

                <Wp_login ref="wp_login" v-show="false"></Wp_login>

                <div class="tip_div">
                    <div v-if="$config.project === 'mini'">
                        <span style="font-size: 16px">注册信息使用说明：</span><br>
                        ①，记录好"会员编号"和"登录密码"，可截图保存；<br>
                        ②，登录后可在"我的"中进行密码修改
                    </div>
                    <div v-else>
                        <span style="font-size: 16px">注册信息使用说明：</span><br>
                        ①，记录好"会员编号"和"登录密码"，可截图保存；<br>
                        ②，识别下方"万品京选"公众号二维码，进行关注；<br>
                        ③，在"万品京选"公众号中选择"登录"；<br>
                        ④，在弹出的登录界面中，输入"会员编号"和"登录密码"即可登录超级会员后台；
                    </div>
                </div>

                <div style="margin-top: 20px; text-align: center">
                    <Wp_image :url="public_url" width="80"></Wp_image>
                    <div style="font-size: 16px; margin-top: 5px">万品京选公众号</div>
                </div>
            </div>

        </van-action-sheet>

    </div>
</template>

<script>
    import Wp_image from "../custom/Wp_image";
    import Wp_login from "../pages_childs/Wp_login";
    import {Dialog} from "vant";
    import wp_img from "../waps_ui/wp_img";

    export default {
        name: "Wp_wx_public_regist",
        components: {wp_img, Wp_login, Wp_image},
        data() {
            return {
                top_img: '/images/logo_02.png',

                fid: "",
                phone_number: '',
                verify_code: '',
                msg: '',
                //注册按钮状态
                regist_button_status: false,
                loading_status: false,
                loading_text: "注册中...",
                //获取验证码按钮状态
                get_verify_button_status: false,
                //注册成功后，弹窗的v-model
                showRegistSuccessData: false,
                //注册成功后的新群主id
                new_user_id: "",
                //注册成功后的新群主登录密码
                new_user_password: "",

                new_user_data: "",
                //公众号二维码地址
                public_url: "/images/wx_public_qr.jpeg",

                get_verify_button_name: "获取验证码",

                time_limit: 60,

                time_tmp: 60,

                open_id: "",

                copyContent: '',
                copy_success: false,
            }
        },

        created() {
            // this.$log(window.location.href)
            // this.redirect_url = encodeURIComponent(window.location.href);

            this.top_img = this.top_img + "?_t=" + new Date().getTime();//加入一个随机数参数，避免缓存严重（小程序）

            this.fid = this.$route.query.fid;
            this.$log("fid = " + this.fid);
            if(!this.fid){
                this.fid = this.$common.getUrlKey("fid");
            }
            this.open_id = this.$route.query.open_id;


            this.time_tmp = this.time_limit;

        },

        methods: {

            loginByOldAccount(){
                if(this.$config.project === 'mini'){
                    this.$common.navigateToMiniProgramPage("/pages/login/login_pw/login_pw");
                }
            },

            login(){
                setTimeout(()=>{
                    let message = "若您已记录好密码，可直接[确认登录]\n登录后，请在[我的]中进行密码修改";
                    if(this.copy_success){
                        message = "账号密码已复制，可粘贴保存\n" + message;
                    }
                    Dialog.confirm({
                        title: "提示",
                        message: message,
                        confirmButtonText: "确认登录",
                        cancelButtonText: "返回记录"
                    }).then(()=>{
                        if(this.$config.project === 'mini'){
                            let value = {
                                username: this.new_user_id,
                                userpwd: this.new_user_password,
                            };
                            let value_str = JSON.stringify(value);

                            this.$common.navigateToMiniProgramPage("/pages/login/login_pw/login_pw?", 'user', value_str);
                        }else{
                            this.$refs.wp_login.username = this.new_user_id;
                            this.$refs.wp_login.password = this.new_user_password;
                            // this.$refs.wp_login.username = "v156";
                            // this.$refs.wp_login.password = "jd53256";
                            this.$refs.wp_login.login(str=>{
                                if(str === "success"){
                                    window.location.href = "/index.html"
                                }
                            });
                        }
                    }).catch(()=>{

                    });
                }, 200)
            },

            onCopySuccess(){
                this.copy_success = true;
            },
            onError(){
                this.copy_success = false;
            },

            timeDown(){
                this.get_verify_button_name = this.time_tmp + "秒后可重新获取"

                if(this.time_tmp >= 0){
                    setTimeout(()=>{
                        this.time_tmp--;
                        this.timeDown();
                    }, 1000)
                }else{
                    this.get_verify_button_status = false;
                    this.get_verify_button_name = "获取验证码";
                    this.time_tmp = this.time_limit;
                }

            },

            /**
             * 弹窗关闭监听
             */
            sheetClose(){
                if(this.$common.gloabl_regist_success_data){
                    this.$dialog.alert({
                        title: "您已成功注册为超级会员",
                        message: '您可以关闭当前页面，前往"万品京选"公众号进行登录，若要查看超级会员注册信息，点击"查看"进行查看',
                        confirmButtonText: "查看",
                    }).then(()=>{
                        this.initSuccessData(this.$common.gloabl_regist_success_data);
                    });
                }
            },

            /**
             * 替换回车
             */
            replaceEnter(str){
                return str.replace(/\n|\r\n/g,"<br/>");
            },

            // checkTest(){
            //     //点击"注册"后，将按钮置为不可用
            //     this.regist_button_status = true;
            //     this.loading_status = true;
            //
            //     let success_data = {msg: "用户注册成功。", u_name: "v156", code: 200, pwd: "jd53256"};
            //
            //     setTimeout(()=>{
            //         this.regist_button_status = false;
            //         this.loading_status = false;
            //         this.initSuccessData(success_data);
            //     },2000)
            // },

            initSuccessData(success_data) {


                //打开弹窗
                this.showRegistSuccessData = true;

                this.$common.gloabl_regist_success_data = success_data;

                this.new_user_id = success_data.u_name;
                this.new_user_password = success_data.pwd;

                let content = "会员编号：" + success_data.u_name + "\n";

                content += "登录密码：" + success_data.pwd;

                this.copyContent = content;

                this.new_user_data = this.replaceEnter(content);

                this.sendMessageToPublic();
            },

            /**
             * 校验验证码，校验成功直接注册
             */
            checkAndRegist() {
                // this.registTest();

                let phoneNumber = this.phone_number;
                let verifyCode = this.verify_code;
                if (phoneNumber && verifyCode && this.$common.isPoneAvailable(phoneNumber)) {
                    let params = {
                        phone: phoneNumber,
                        code: verifyCode,
                    };

                    //点击"注册"后，将按钮置为不可用
                    this.regist_button_status = true;
                    this.loading_status = true;

                    this.$checkPhoneVerifyCode(params, response => {
                        this.$log(response)
                        // {code: 200, message: "验证码正确,通过验证"}
                        if (response.code === 200) {
                            //验证通过,请求注册
                            this.regist();
                        }else{
                            this.$dialog.alert({
                                message: response.message
                            });
                        }

                        this.regist_button_status = false;
                        this.loading_status = false;
                    })
                } else {
                    this.$dialog.alert({
                        message: "请输入正确的手机号码和验证码"
                    });
                }
            },

            registTest(){
                let response= {msg: "用户注册成功。", u_name: "s101", code: 200, pwd: "123456"};
                if (response.code === 200) {
                    this.$common.gloabl_regist_success_data = response;

                    // this.sendMessageToWechat();

                    this.initSuccessData(response);

                }else{
                    this.$dialog.alert({
                        message: response.msg
                    });
                }
            },

            regist() {

                let params = {
                    fid: this.fid,
                    phone: this.phone_number,
                };

                this.$getPhoneRegist(params, response => {
                    this.$log(response);
                    //{msg: "用户注册成功。", u_name: "test003", code: 200, pwd: "6QJ4kybB"}
                    // {msg: "用户注册成功。", u_name: "1924367099", code: 200, pwd: "12463078"}
                    if (response.code === 200) {
                        this.$common.gloabl_regist_success_data = response;

                        this.sendMessageToWechat();

                        this.initSuccessData(response);

                    }else{
                        this.$dialog.alert({
                            message: response.msg
                        });
                    }

                })
            },

            /**
             * 注册成功后发送消息到指定微信群
             */
            sendMessageToWechat(){

                let params = {
                    content: "新用户注册成功：\n会员编号：" + this.$common.gloabl_regist_success_data.u_name
                        + "\n手机号：" + this.phone_number + "\n上级编号：" + this.fid + "\n请尽快联系此用户"
                };
                // if(this.phone_number.indexOf("137163214") < 0){
                //
                // }
                this.$sendMessageToWechat_ByTs(params, response=>{
                    this.$log(response)
                })
            },

            /**
             * 注册成功后发送账号密码到公众号
             */
            sendMessageToPublic(){

                if(this.open_id){
                    let time = this.$common.dateFmt("yyyy-MM-dd hh:mm", this.$common.dateAdd('d', 0, new Date()));
                    let params = {
                        "touser": this.open_id,
                        // "touser": "oX_N4tzqMKvYqHsByECDfLgOOkD8",
                        "site": "wpjx",
                        "url": "http://jd.wapg.cn",
                        "title": "尊敬的万品京选超级会员，您的账号已开通",
                        "account_name": this.$common.gloabl_regist_success_data.u_name,
                        "account_pwd": this.$common.gloabl_regist_success_data.pwd,
                        "reg_time": time,
                        "desc": "请尽快修改初始密码，并保存好账号和登录密码。如有疑问请与京东小妹联系。"
                    };
                    this.$sendMessageToPublic(params, response=>{
                        this.$log(response)

                        if(response && response.code === 200){
                            if(this.$store.state.original_p){
                                let user = this.$store.state;
                                user.original_p = "";
                                // user.userPhone = "";
                                this.$store.commit('login', user);
                            }
                        }else{
                            //如果发送账号密码到公众号失败，则先存储原始密码original_p
                            let user = this.$store.state;
                            user.original_p = this.$common.gloabl_regist_success_data.pwd;
                            // user.userPhone = "";
                            this.$store.commit('login', user);
                        }
                    })
                }else{
                    //如果没获取到微信openid，则直接存储原始密码original_p
                    let user = this.$store.state;
                    user.original_p = this.$common.gloabl_regist_success_data.pwd;
                    // user.userPhone = "";
                    this.$store.commit('login', user);
                }

            },

            /**
             * 获取验证码
             */
            getVerifyCode() {
                let phoneNumber = this.phone_number;
                if (phoneNumber && this.$common.isPoneAvailable(phoneNumber)) {
                    let params = {
                        phone: phoneNumber,
                    };

                    this.get_verify_button_status = true;

                    // this.timeDown();

                    this.$getPhoneVerifyCode(params, response => {
                        this.$log(response)
                        // {code: 200, message: "验证码发送成功"}
                        if (response.code === 200) {
                            //获取到验证码
                            //启动倒计时
                            this.timeDown();
                        } else if (response.code > 200) {
                            this.get_verify_button_status = false;
                            this.$dialog.alert({
                                message: response.message
                            });
                        }
                    });
                } else {
                    this.$dialog.alert({
                        message: "请输入正确的手机号码"
                    });
                }
            },

            // /**
            //  * 判断手机号码有效
            //  * @param phone_number
            //  * @return {boolean}
            //  */
            // isPoneAvailable(phone_number) {
            //     var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
            //     if (!myreg.test(phone_number)) {
            //         return false;
            //     } else {
            //         return true;
            //     }
            // }
        },

    }
</script>

<style scoped>

    .regist_input_div {
        margin-top: 5%;
        padding: 2px;
        border-radius: 4px;
        border: 1px solid #E52212
    }

    .regist_input {
        font-size: 16px
    }

    .code_button {
        height: 50px;
        width: auto;
        /*border-left: 2px solid red;*/
        /*border-right: 0px;*/
        /*border-top: 0px;*/
        /*border-bottom: 0px;*/
        border: 0px;
        /*border-radius: 0px;*/
        padding: 0px;
        /*padding-right: 5px;*/
        /*text-align: right;*/
        position: absolute;
        /*background-color: #aaaaaa;*/
        right: 30px;
    }

    .success_data_div {
        /*border: 1px solid #77FFCC55;*/
        border: 1px solid #E52212;
        border-radius: 4px;
        padding: 10px;
        /*background-color: #77FFCC22;*/
        background-color: #03FFF211;
        font-size: 17px;
        line-height: 32px;
    }

    .tip_div {
        margin-top: 20px;
        border: 1px solid #03FFF255;
        border-radius: 4px;
        padding: 10px;
        background-color: #03FFF222;
        font-size: 15px;
        line-height: 25px;
    }
</style>